import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  isDevMode,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { offlineInterceptor } from './core/interceptor/offline.iterceptor';
import { Configuration } from './core/interface';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(), // Uses modern Fetch API instead of XMLHttpRequest
      withInterceptors([offlineInterceptor]), // Functional interceptors
    ),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideServiceWorker('custom-sw.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: Configuration,
      useFactory: () => new Configuration({ basePath: environment.apiUrl }),
    },
  ],
};
